import { render, staticRenderFns } from "./UrbanRenewalSelectLayout.vue?vue&type=template&id=9044e74c"
import script from "./UrbanRenewalSelectLayout.vue?vue&type=script&lang=js"
export * from "./UrbanRenewalSelectLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports